import ApiService from '@/services/api.service'

const InpatientProcService = {
    getAll(parameter) {
        const requestData = {
            method: 'get',
            url: "/InpatientProcs/",
            headers: {
            },
            params: parameter
        }
        return ApiService.customRequest(requestData);
    },

    getInpatientProc(recId) {
        return ApiService.get(`/InpatientProcs/${recId}`);
    },

    addInpatientProc(data) {
        return ApiService.post(`/InpatientProcs/`,data);
    },

    deleteInpatientProc(recId) {
        return ApiService.delete(`/InpatientProcs/${recId}`);
    },

    updateInpatientProc(recId, data) {
        return ApiService.put(`/InpatientProcs/${recId}`,data);
    },
}

export default InpatientProcService;
